import React from 'react';

import GenericTestimonial, { type ReviewProps as TestimonialItem } from '@lendi-jam/generic-testimonial';
import { Script } from "gatsby";

import { GenericTestimonialContent } from '#contentTypes/GenericTestimonial';

interface PrismicTestimonialProps {
  component: GenericTestimonialContent;
}

const GenericPrismicTestimonial: React.FC<PrismicTestimonialProps> = ({ component }) => {
  const testimonialContent = component.primary;
  const testimonialItems: TestimonialItem[] = component.items.map((item) => ({
    title: item.review_title.text,
    author: item.author.text,
    date: item.date,
    description: item.text.text,
    location: item.location.text,
  }));

  // Iterate over testimonials to get review object for SEO
  const reviewForSeo = testimonialItems.map((testimonial) => (
    {
      "@type": 'Review',
      author: {
        "@type": "Person",
        name: testimonial.author
      },
      reviewBody: testimonial.description,
      datePublished: testimonial.date,
      name: testimonial.title,
      reviewRating: {
        "@type": "Rating",
        ratingValue: '5'
      }
    }
  ))

  return (
    <>
      {/* Applicable for General Testimonials only */}
      <Script type="application/ld+json" >
        {JSON.stringify({
          "@content": "https://schema.org",
          "@type": "Home Loan Specialist",
          "@id": "https://www.lendi.com.au",
          name: 'Lendi',
          description: 'We know applying for a home loan and refinancing can be a drag. \
          Long lines at the bank, stacks of paperwork and confusing application processes.\
          Well, not with Lendi. We\'re changing the game so you can search, choose and settle your home loan online. \
          Plus, we won\’t charge you for any home loan help. \
          With access to over 25 lenders through only one application, you can get home loan answers in minutes instead of weeks.',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Level 9, 37 Pitt St',
            addressLocality: 'Sydney',
            addressRegion: 'NSW',
            postalCode: '2000',
            addressCountry: 'Australia',
          },
          review: {reviewForSeo}
        })}
      </Script>
      <GenericTestimonial
        heading={testimonialContent.heading.text}
        subTitle={testimonialContent.subtitle.text}
        logo={testimonialContent.logo}
        variant={testimonialContent.variant}
        buttonLink={testimonialContent.button_link.url || ''}
        items={testimonialItems}
      />
    </>

  );
};

export default GenericPrismicTestimonial;
